import React from "react";
import {dayMonthYearAtTime} from "../../utils/dates";

class GridDevices {
  title = 'Lista de Dispositivos';
  columns = [
    {
      Header: "Nome",
      accessor: "friendlyName"
    },
    {
      Header: "Criado em",
      accessor: "createdAt",
      Cell: row => row.original.createdAt && dayMonthYearAtTime(row.original.createdAt)
    }
  ];
  endpoint = "cloud/v1/devices";
}

export default GridDevices;



// WEBPACK FOOTER //
// ./src/customGrid/entities/Devices.js